import ApplicationController from './application_controller'
import SlimSelect from 'slim-select'
import 'slim-select/styles'

export default class extends ApplicationController {
  static targets = ['select']

  connect() {
    if (this.hasSelectTarget) {
      this.initSlimSelect()
    }
  }

  initSlimSelect() {
    const allowEmailCreation = this.selectTarget.dataset.allowEmailCreation === 'true'
    
    this.slimSelect = new SlimSelect({
      select: this.selectTarget,
      placeholder: this.selectTarget.dataset.placeholder || 'email@exemple.com',
      settings: {
        allowDeselect: true,
        closeOnSelect: false
      },
      events: {
        addable: allowEmailCreation ? (value) => this.validateAndAddEmail(value) : null
      }
    })
  }

  validateAndAddEmail(value) {
    const email = value.trim().replace(/,$/, '')
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    
    if (emailRegex.test(email)) {
      return { text: email, value: email }
    }
    
    const container = this.selectTarget.nextElementSibling
    if (container) {
      container.classList.add('ss-invalid-email')
      setTimeout(() => {
        container.classList.remove('ss-invalid-email')
      }, 500)
    }
    
    return null
  }
} 